export const UPDATE_SELECTED_PAYOUT_ACCOUNTS = 'PAYOUT_ACCOUNT_SELECTOR/UPDATE_SELECTED';
export const TOGGLE_SELECTOR_OPEN = 'PAYOUT_ACCOUNT_SELECTOR/TOGGLE_SELECTOR_OPEN';

export function updateSelectedPayoutAccounts(payoutAccounts, isAllSelected) {
    return {
        isAllSelected,
        payoutAccounts,
        type: UPDATE_SELECTED_PAYOUT_ACCOUNTS
    };
}

export function toggleSelectorOpen(isClosed, selectedPayoutAccounts) {
    return {
        isClosed,
        selectedPayoutAccounts,
        type: TOGGLE_SELECTOR_OPEN
    };
}

export function generatePayoutAccountIdsString(payoutAccounts = []) {
    return payoutAccounts.map((payoutAccount = {}) => payoutAccount.payoutAccountId).join();
}
